<template>
  <div class="recommend" ref="container">
    <div class="title acea-row row-center-wrapper">
      <span class="iconfont icon-zhuangshixian"></span>
      <span class="name">店长推荐</span>
      <span class="iconfont icon-zhuangshixian lefticon"></span>
    </div>
    <div class="recommendList acea-row row-between-wrapper">
      <router-link :to="{ path: '/detail/' + item.id }" class="item" v-for="(item, index) in productList" :key="index">
        <div class="pictrue">
          <img :src="item.image" class="image" />
        </div>
        <div class="name line1">{{ item.store_name }}</div>
        <div class="money font-color-red">
          <span v-show="item.price !== '请先登录'">￥</span>
          <span class="num">{{ item.price }}</span>
        </div>
      </router-link>
    </div>
    <Loading :loaded="loadend" :loading="loading"></Loading>
  </div>
</template>
<script>
  import {
    getHostProducts
  } from "@api/store";
  import Loading from "@components/Loading";
  export default {
    name: "ProductList",
    props: {
      productList: {
        type: Array,
        default: []
      }
    },
    components: {
      Loading
    },
    data: function () {
      return {
        page: 1,
        limit: 20,
        loadTitle: "",
        loading: false,
        loadend: false
      };
    },
    mounted: function () {
      // this.$scroll(this.$refs.container.parentElement, () => {
      //   !this.loading && this.getProducts();
      // });
    },
    methods: {
      getProducts: function () {
        let that = this;
        if (that.loading) return; //阻止下次请求（false可以进行请求）；
        if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
        that.loading = true;
        getHostProducts(that.page, that.limit).then(res => {
          that.loading = false;
          //apply();js将一个数组插入另一个数组;
          that.productList.push.apply(that.productList, res.data);
          that.loadend = res.data.length < that.limit; //判断所有数据是否加载完成；
          that.page = that.page + 1;
        });
      }
    }
  };
</script>
